const getPageTitle = (t: (pageTitle: string) => string): string => {
  const pageTitle = t('pageTitle')
  return `MiiMOSA - ${pageTitle}`
}

export default getPageTitle
